import React from 'react'
import "./costOfGoods.scss";
import { currencySignAndNegativeValueAdjust } from '../../../utils/commonFunctions';

type AppProps = {
    data: number;
    sideHeading: string;
    currencySign: string | undefined;
}

const CostOfGoodsFooter = ({ data, currencySign, sideHeading }: AppProps) => {
    return (
        <div className="report-footer">
            <div style={{ width: "75%", paddingLeft: "1%" }}>{sideHeading}</div>
            <div style={{ width: "25%", paddingLeft: "4%" }}>{data ? currencySignAndNegativeValueAdjust(currencySign,data?data?.toFixed(2)?.toString():"") : 0}</div>
        </div>
    )
}

export default CostOfGoodsFooter